import DTO from './DTO';

class ApplicationsDialogDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'rejection_reason_id',
        type: String,
        validators: {},
        labelKey: 'base',
      },
      {
        name: 'rejection_reason_ids',
        type: String,
        validators: {},
        labelKey: 'rejection_reason_ids',
      },
      {
        name: 'additional_rejection_reason_id',
        type: String,
        validators: {},
        labelKey: 'base2',
      },
      {
        name: 'additional_rejection_reason',
        type: String,
        validators: {},
        labelKey: 'base2',
      },
      {
        name: 'rejection_reason_note',
        type: String,
        validators: {},
        labelKey: 'comment',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default ApplicationsDialogDTO;
